import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dummyImg from "../../assets/images/dummyImg.png";
import FetchData from "../../providers/dataProvider";

const ViewDistributor = () => {
  const location = useLocation();
  const [viewItem, setViewItem] = useState(null);
  const navigate = useNavigate();
  const { data: designationList } = FetchData("designation");
  const { data: currencyList } = FetchData("currency");
  const { data: documentList } = FetchData("distributorDocuments");
  const { data: assignedEngineerList } = FetchData("userprofile");
  const { data: paymentTermsData } = FetchData("paymentterms");
  const { data: deliveryTermsData } = FetchData("deliveryterms");

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      const itemCopy = { ...item };
      const desigObj = designationList?.find(
        (el) => el?.id == item?.designationId
      );
      const currencyObject = currencyList?.find(
        (el) => el?.id == item?.currencyId
      );
      if (desigObj) itemCopy["designationName"] = desigObj?.designationName;
      if (currencyObject)
        itemCopy["currencyName"] = currencyObject?.currencyName;
      itemCopy["shortCode"] = currencyObject?.shortCode;
      if (itemCopy) {
        itemCopy?.distributorContacts?.map((obj) => {
          const designationObj = designationList?.find(
            (el) => el?.id == obj?.designationId
          );
          if (designationObj)
            obj["designationName"] = designationObj?.designationName;
          else obj["designationName"] = "";
          return obj;
        });
        itemCopy?.distributorDocument?.map((obj) => {
          const documentObj = documentList?.find(
            (el) => el?.id == obj?.attachmentId
          );
          if (documentObj) obj["documentName"] = documentObj?.documentName;
          else obj["documentName"] = "";
          return obj;
        });
        const authData = assignedEngineerList.find(item => item?.identityId === itemCopy?.authorizedPerson)
        if (authData) itemCopy["authorizedPersonName"] = authData?.firstName + " " + authData?.lastName
      }
      setViewItem(itemCopy);
    } else if (location?.state == null) {
      navigate("/dashboard");
    }
  }, [location?.state, designationList, currencyList, documentList,assignedEngineerList]);

  return (
    <div className="container-fluid view-distributor-sec">
      <section className="distributor-view-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div class="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/distributor-master">
                    <button className="btn p-0 mr-2" type="button">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1>General</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Distributor Name</h5>
                      <h6>{viewItem?.distributorName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Distributor Type</h5>
                      <h6>{viewItem?.type}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewItem?.countryName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Fax Number</h5>
                      <h6>{viewItem?.fax}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Phone Number</h5>
                      <h6>{viewItem?.phone}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Email Address</h5>
                      <h6>{viewItem?.email}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Website</h5>
                      <h6>{viewItem?.website}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Address</h5>
                      <h6>{viewItem?.address}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Assigned Engineer</h5>
                      <h6>{viewItem?.assignedEngineerName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Currency</h5>
                      <h6>{viewItem?.shortCode}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Conversion Rate</h5>
                      <h6>{viewItem?.conversionRate}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Company Name</h5>
                      <h6>{viewItem?.companyName}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Authorized Person</h5>
                      <h6>{viewItem?.authorizedPersonName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Position</h5>
                      <h6>{viewItem?.designationName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Status</h5>
                      <h6>{viewItem?.status}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <h5>Additional Info</h5>
                      <h6>{viewItem?.additionalInfo}</h6>
                    </div>
                  </div>
                </div>
                <div className="row distributor-document-upload-row mt-3">
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Company Logo</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Letterpad Header</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Letterpad Footer</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-2">
              <div className="card-header pl-3">
                <h1>Documents</h1>
              </div>
              <div className="card-body">
                <div className="row">
                  {viewItem?.distributorDocument?.length > 0 ? (
                    viewItem?.distributorDocument?.map((doc) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 mb-4">
                        <div className="uploaded-documents">
                          <i class="far fa-file-pdf"></i>
                          <p>{doc?.documentName}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                     <div className="col-12">
                      <p className="m-0">No files</p>
                    </div>
                  )}
                </div>
              </div>
            </div>  
            <div className="card mb-2">
              {viewItem?.distributorPaymentTerms?.length > 0 && (<><div className="card-header pl-3">
                <h1>Payment Terms</h1>
              </div>
                <div className="card-body p-0 payment-terms-card-body">
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <th>Sl. No</th>
                            <th>Payment Term</th>
                          </tr>
                        </thead>
                        <tbody>
                          {viewItem?.distributorPaymentTerms?.map((obj, index) => {
                            return (
                              <tr>
                                <td>{index * 1 + 1}</td>
                                <td>{paymentTermsData?.find((item) => item.id === obj.paymentTermId)?.paymentDescription}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div></>)}
            </div>
            <div className="card mb-2">
              {viewItem?.distributorDeliveryTerms?.length > 0 && (<><div className="card-header pl-3">
                <h1>Delivery Terms</h1>
              </div>
                <div className="card-body p-0 delivery-terms-card-body">
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <th>Sl. No</th>
                            <th>Delivery Term</th>
                          </tr>
                        </thead>
                        <tbody>
                          {viewItem?.distributorDeliveryTerms?.map((obj, index) => {
                            return (
                              <tr>
                                <td>{index * 1 + 1}</td>
                                <td>{deliveryTermsData?.find((item) => item.id === obj.deliveryTermId)?.deliveryDescription}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div></>)}
            </div>
            <div className="card">
              <div className="card-header pl-3 d-none">
                <h1>Credit Limit Approval</h1>
              </div>
              <div className="card-body d-none">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Requested Additional Open Credit</h5>
                      <h6>25000</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Available LC Credit</h5>
                      <h6>0</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div className="mt-4">
                      <h6 style={{ color: "#60EB8A" }}>
                        Credit approval is in process
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header pl-3">
                <h1>Contacts</h1>
              </div>
              <div className="card-body">
                <div className="row mt-2 contact-view-area">
                  {viewItem?.distributorContacts?.length > 0 ? (
                    viewItem?.distributorContacts?.map((obj) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                        <div className="view-contact">
                          <i className="far fa-user-circle"></i>
                          <h5>{obj?.name}</h5>
                          <span>{obj?.email}</span>
                          <p>{obj?.designationName}</p>
                          <p>{obj?.phone}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 no-contact">
                      <p>No contacts avilable</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/distributor-master">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewDistributor;
